module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "showClose": false,
      "placeInTop": true
    }
  }, [_c('div', {
    staticClass: "do-modal do-modal__edit-user-norm",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "do-modal__header"
  }, [_c('h2', [_vm._v("Rediger " + _vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "do-spinner__container"
  }, [_c('div', {
    staticClass: "do-spinner do-spinner--large"
  })]) : _vm._e(), _vm._v(" "), _c('AssignHoursNormList', {
    attrs: {
      "isNetto": false,
      "schoolYear": _vm.schoolYear,
      "theEditUserNorm": _vm.theEditUserNorm
    },
    on: {
      "updated": _vm.setItemsToSave,
      "changedSum": _vm.setNettoTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "do-modal__footer"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isUpdating
    },
    on: {
      "click": _vm.onUpdate
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.update')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1aa916e9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursNormEditIUserModal.vue
// module id = 1783
// module chunks = 1